import { lazy } from 'react';

export const IncCorAddLazy = lazy(() => import('./IncCorAdd'));
